import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class EmployeeGuard {
  private readonly user_service = inject(UserService);

  async canActivate(_route: ActivatedRouteSnapshot): Promise<boolean> {
    const user: User = this.user_service.getCurrentUser();
    return user != null && user.role.slug === 'worker';
  }
}
